import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import useGetAttributes from "../../hooks/useGetAttributes";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import useFetchContacts from "../../hooks/useFetchContacts";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";

const MODULE_NAMES = ["Insurance Products", "Property Documentation", "PROPERTY"];
export default function PropertyDocumentation() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Property Documentation");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const {
    errorState,
    fetchData,
    fieldsData,
    disasterAttributeData,
    loadingState,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { disasterAttribute } = useGetAttributes(MODULE_NAMES, setLoading);
  const { contactList } = useFetchContacts(setLoading);

  const history = useHistory();
  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddInsurance = () => {
    history.push("/insurance_new");
  };
  const Addinventory = () => {
    history.push("/inventory_new");
  };
  const AddDocument = () => {
    history.push("/orgainzer/important-document");
  };
  const collapseableTables = [
    { title: "Property Insurance Information", key: 1, OnClick: AddInsurance },
    { title: "Agent Contact Information", key: 2, OnClick: AddContact },
    { title: "Inventory", key: 3, OnClick: Addinventory },
  ];
  const recordsTable = [
    { title: "Property Tax Records", key: 1 },
    { title: "Mortgage Information", key: 2 },
  ];
  const tableDataObj = {
    "Property Insurance Information": tableData.insuranceProductsData,
    Inventory: tableData.pROPERTYData,
  };
  const propertyDocCols = {
    "Property Insurance Information": [
      {
        title: "Carrier",
        dataIndex: "Carrier",
        key: "carrier",
      },
      {
        title: "Policy Number",
        dataIndex: "Policy Number",
        key: "policyNumber",
      },
      {
        title: "View Policy",
        dataIndex: "View Policy",
        key: "viewpolicy",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
    ],
    "Agent Contact Information": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "company",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
    ],
    Inventory: [
      {
        title: "Property Name",
        dataIndex: "name",
        key: "propertyname",
      },
      {
        title: "Room Name",
        dataIndex: "Room Name",
        key: "roomname",
      },
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
      },
      {
        title: "Value",
        dataIndex: "Value",
        key: "value",
      },
    ],
    "Property Tax Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
    ],
    "Mortgage Information": [
      {
        title: "Mortgage Service",
        dataIndex: "Mortgage Service",
        key: "mortgageservice",
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "accountnumber",
      },
      {
        title: "Payment Due Date",
        dataIndex: "Payment Due Date",
        key: "paymentduedate",
      },
      {
        title: "Maturity Due Date",
        dataIndex: "Maturity Due Date",
        key: "maturityduedate",
      },
    ],
  };

  console.log("tableData", tableData);
  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <h2 className="parent-title">Property Documentation</h2>
        <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute && disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      {collapseableTables.map((table, idx) => (
        <CollapseableTable title={table.title} key={table.key} onClick={table.OnClick}>
          <Table
            columns={propertyDocCols && propertyDocCols[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}
      {recordsTable.map((table, idx) => (
        <CollapseableTable title={table.title} key={table.key} onClick={AddDocument}>
          <Table columns={propertyDocCols && propertyDocCols[table.title]} />
        </CollapseableTable>
      ))}
      <NewLoader isLoading={loading} />
    </div>
  );
}
